import React from 'react';
import InputMask from "react-input-mask";
import './styles.css'

const InputText = (props) => (

  <div className="inputTelefone" >
    <InputMask
      className="telefone"
      name={props.name}
      label={props.label}
      placeholder={props.placeholder}
      onChange={props.onChange}
      required
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      defaultValue={props.defaultValue}
      type={props.type}
      mask={props.mask}
    />
    <label>
      {props.label} *
    </label>
  </div>
);

export default InputText;
